
<a
  routerLinkActive="bl-menu__link--active"
  title="Management"
  class="bl-menu__link--dark"
>
  <i class="pi pi-user"></i>
  <span *ngIf="user">
    {{ contentText }} <strong>{{ user.mail }}</strong>?
  </span>
</a>
<!--p-menu #menu2 [model]="items" [popup]="true" appendTo="body" />

<p-dialog
  [header]="headerText"
  [modal]="true"
  [responsive]="true"
  [maximizable]="false"
  [baseZIndex]="10000"
  [closable]="false"
  [style]="{ width: '30rem' }"
  [(visible)]="opened"
>
  <p *ngIf="user; else elseBlock">
    {{ contentText }} <strong>{{ user.mail }}</strong>?
  </p>
  <ng-template #elseBlock>{{ contentText }}</ng-template>
  <div style="display: flex;">
    <button type="button" pButton label="Cancel" (click)="cancel()"></button>
    <button
      type="button"
      pButton
      [label]="submitBtnText"
      class="ui-button-secondary"
      (click)="submit()"
    ></button>
  </div>
</p-dialog-->
